/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/event";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/event";

export const resetActionSuccess = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_ACTION_SUCCESS
    })
  }
}
